export const DEMAND_DESCRIPTION_PLACEHOLDER = 'Tarefas sem demanda'
